module.exports = __webpack_public_path__ + "img/11.22772b59.png";